import React from "react";
import { Container, Form } from "react-bootstrap";
import useReveal from "../useReveal";
import "./Style.scss";

const DematAccount = () => {
  const revealRef = useReveal();

  return (
    <section className="homeDemat">
      <Container className="homeDemat__inner homeReveal" ref={revealRef}>
        <div className="homeDemat__band">
          <span className="homeDemat__icon" aria-hidden="true">
            <i className="fas fa-user-plus" />
          </span>
          <h2>Open an Algoquant Global account</h2>
          <p>A fast, hassle-free way to get started.</p>
          <Form className="homeDemat__form" onSubmit={(e) => e.preventDefault()}>
            <div className="homeDemat__fields">
              <input
                type="text"
                name="name"
                id="account-name"
                placeholder="Enter name"
                required
                aria-label="Name"
              />
              <input
                type="email"
                name="email"
                id="account-email"
                placeholder="Enter email"
                required
                aria-label="Email"
              />
              <input
                type="tel"
                name="number"
                id="account-number"
                placeholder="Enter number"
                required
                aria-label="Phone number"
              />
            </div>
            <button type="submit" className="homeCtaPrimary homeDemat__submit">
              Sign Up
              <i className="fas fa-arrow-right" aria-hidden="true" />
            </button>
          </Form>
        </div>
      </Container>
    </section>
  );
};

export default DematAccount;
